import axiosInstance, { microServices } from 'network/apis/index'
import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'utils/constants/index'

export const getAllCurrencyService = () => {
  return axiosInstance(METHOD_TYPES.get, 'common/all-currencies', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table
  })
}
export const getGameSettingService = (params) => {
  return axiosInstance(METHOD_TYPES.get, 'common/game-settings', {}, {
    params,
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table
  })
}
